export interface DocumentComment {
  id: number
  attorneyName: string | null
  attorneyAvatarUrl: string | null
  comment: string
  created: string
}

export interface Document {
  id: number
  name: string
  status: string
  uploaded: string
  comments?: DocumentComment[]
}

export interface DocumentCategory {
  id: number
  name: string
  description: string
  subcategoryList: string
  status: string
}

export interface DocumentReview {
  comments: DocumentComment[]
  id: number
  name: string
  status: string
  toReview: boolean
  uploaded: string
  opened: string | null
}

export interface ManualUploadCertData {
  generalDocumentId: number
  generalDocumentName: string
  generalDocumentDescription: string
  generalDocumentStatus: string
  generalDocumentSubcategoryList: string
  certificateDocumentId: number
  certificateDocumentName: string
  certificateDocumentDescription: string
  certificateDocumentStatus: string
  certificateDocumentSubcategoryList: string
}

export interface DocumentRequestChecklistItem {
  id: number
  name: string | null
  status: string | null
  documentCount: number
  comment: string | null
  hasWarnings: boolean
  durationDescription: string | null
  documentItemTypeId: number
}

export interface CheckListDocument {
  matterDocumentChecklistItemDocumentId: number
  matterCheckListItemId: number
  matterDocumentId: number
  clientPortalDocumentId: number
  name: string | null
  status: string | null
  uploaded: string | null
  comments: string | null
}

export interface DocumentGapDate {
  gapType: number
  name: string | null
  group: string | null
  startDate: string | null
  endDate: string | null
  message: string | null
}

export interface DocumentChecklistGaps {
  success: boolean
  errorMessage: string | null
  documentChecklistItemDates: DocumentGapDate[]
  groupHeaderName: string | null
  hasWarnings: boolean
  hasTotalsSubtractionWarnings: boolean
}

export enum DocumentCheckListItemType {
  Unknown = 0,
  BankAccountStatements = 1,
  FederalTaxReturns = 2,
  CertificateOfCreditCounseling = 3,
  Paystubs = 4,
  Other = 5,
  DriversLicenseOrStateID = 6,
  SocialSecurityCard = 7,
  Passport = 8
}
